import React, { ReactElement } from 'react'
import { RecipeWithQuantity } from '@mindfulchefuk/features/Recipes/interfaces'
import { logRecipeClick } from '@mindfulchefuk/features/Onboarding/utils/onboardingAnalytics'
import styled from '@emotion/styled'
import { Flex, ResetButton, Stack, theme } from '@mindfulchefuk/design-system'
import { RecipeCardWithClaimsImage } from '@mindfulchefuk/features/Recipes/components/RecipeCardWithClaims/RecipeCardWithClaimsImage/RecipeCardWithClaimsImage'
import { RecipeCardWithClaimsFooter } from '@mindfulchefuk/features/Recipes/components/RecipeCardWithClaims/RecipeCardWithClaimsFooter/RecipeCardWithClaimsFooter'

export type TRecipeCardWithClaims = {
  isBasketFull: boolean
  isWithinOrderWindow?: boolean
  onAddRecipe: () => void
  onClick?: () => void
  onSubtractRecipe: () => void
  position?: number
  recipe: RecipeWithQuantity
  showPrice?: boolean
}

const RecipeCardBox = styled(Flex)`
  transition: transform ease-in-out 0.1s;

  &:hover {
    box-shadow: ${theme.shadows.standard};
    transform: scale(1.01);
  }
`

export const RecipeCardWithClaims = ({
  isBasketFull = false,
  isWithinOrderWindow = true,
  onAddRecipe,
  onClick,
  onSubtractRecipe,
  position,
  recipe,
  showPrice = true,
}: TRecipeCardWithClaims): ReactElement => {
  const { claims, foodGroup, id, imageUrl, portions, price, title } = recipe

  const handleClick = () => {
    if (onClick) {
      onClick()
    }
    logRecipeClick({ foodGroup, portions, position, price, id })
  }

  return (
    <RecipeCardBox
      flexDirection="column"
      overflow="visible"
      justifyContent="space-between"
      height="100%"
      bg="white"
      data-testid="recipe-card-with-claims"
    >
      <ResetButton onClick={handleClick} height="100%">
        <Stack data-testid="modal-button" textAlign="left" height="100%">
          <RecipeCardWithClaimsImage
            claims={claims}
            imgAltText={title}
            imgUrl={imageUrl}
            productId={recipe.id}
            productName={recipe.title}
          />
          <RecipeCardWithClaimsFooter
            isBasketFull={isBasketFull}
            isWithinOrderWindow={isWithinOrderWindow}
            onAddRecipe={onAddRecipe}
            onSubtractRecipe={onSubtractRecipe}
            recipe={recipe}
            showPrice={showPrice}
          />
        </Stack>
      </ResetButton>
    </RecipeCardBox>
  )
}
